export default {
  data() {
    return {
      sortKey: '',
      isAsc: true,
      filters: {},
      isCollapsed: false,
      manualFilterCount: 0,
      filterAuto: false,
    }
  },

  computed: {
    sort() {
      if (!this.sortKey) return ''
      return this.isAsc ? this.sortKey : `-${this.sortKey}`
    },

    appliedFilterCount() {
      if (!this.filterAuto) {
        return this.manualFilterCount
      }

      let count = 0
      Object.values(this.filters).forEach(value => {
        if (Array.isArray(value)) {
          if (value.length) count += 1
        } else if (typeof value === 'object' && value !== null) {
          if (value.startDate || value.endDate) count += 1
        } else if (
          value !== ''
          && value !== null
          && value !== undefined
          && value !== false
        ) {
          count += 1
        }
      })
      return count
    },
  },

  methods: {
    updateFilterCount() {
      let count = 0
      Object.values(this.filters).forEach(value => {
        if (Array.isArray(value)) {
          if (value.length) count += 1
        } else if (typeof value === 'object' && value !== null) {
          if (value.startDate || value.endDate) count += 1
        } else if (
          value !== ''
          && value !== null
          && value !== undefined
          && value !== false
        ) {
          count += 1
        }
      })

      this.manualFilterCount = count
    },
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
      }
    },
  },
}
